var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 6.38333L7.32533 2.95L5.60867 4.66667C5.35311 4.92222 5.03644 5.05 4.65867 5.05C4.28089 5.05 3.96422 4.92222 3.70867 4.66667L0.192 1.11667C0.0697778 0.994445 0.00588889 0.841667 0.000333333 0.658333C-0.00522222 0.475 0.0586667 0.316667 0.192 0.183333C0.314222 0.0611111 0.469778 0 0.658667 0C0.847556 0 1.00311 0.0611111 1.12533 0.183333L4.65867 3.71667L6.37533 2C6.63089 1.74444 6.94756 1.61667 7.32533 1.61667C7.70311 1.61667 8.01978 1.74444 8.27533 2L11.7253 5.45V4.38333C11.7253 4.19444 11.7892 4.03611 11.917 3.90833C12.0448 3.78056 12.2031 3.71667 12.392 3.71667C12.5809 3.71667 12.7392 3.78056 12.867 3.90833C12.9948 4.03611 13.0587 4.19444 13.0587 4.38333V7.05C13.0587 7.23889 12.9948 7.39722 12.867 7.525C12.7392 7.65278 12.5809 7.71667 12.392 7.71667H9.72533C9.53644 7.71667 9.37811 7.65278 9.25033 7.525C9.12256 7.39722 9.05867 7.23889 9.05867 7.05C9.05867 6.86111 9.12256 6.70278 9.25033 6.575C9.37811 6.44722 9.53644 6.38333 9.72533 6.38333H10.792Z",
    fill: "#AF2F3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/trending_down.b829510dc4e6b314f492f06f49c6fd29.svg";
export { ForwardRef as ReactComponent };